import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import uniqueId from 'lodash/uniqueId';
import CircleProgressBar from './CircleProgressBar';
import { CDNImgUrl } from '../../../utils/CDNImgUrl';
import useVisibility from '../../../hooks/useVisibility';

const Counter = ({ counter }) => {
    const [, currentElement] = useVisibility(100);
    const icon = _get(counter, 'relationships.field_image.relationships.field_media_image.uri.value');
    const [file, setFile] = useState(CDNImgUrl(icon));
    const type = _get(counter, "internal.type", "");
    const paragraphClasses = `${type} ${type}_${counter?.id}`;

    useEffect(() => {
        setFile(CDNImgUrl(icon));
    }, [icon]);

    return (
        <div className={`counter-wrapper ${paragraphClasses}`} key={uniqueId()}>
            <div className="counter-inner" ref={currentElement}>
                <CircleProgressBar
                    className="counter-figure"
                    numberValue={counter.field_number}
                    legendText={counter.field_counter_text}
                    icon={icon ? file : null}
                    speed={200}
                    maxSize="300px"
                    counterId={counter.id}
                />
            </div>
        </div>
    );
};

export default Counter;

Counter.propTypes = {
    counter: PropTypes.any,
};
